import React, { useState } from 'react';
import { 
  BarChart, 
  Bar, 
  LineChart, 
  Line, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend, 
  ResponsiveContainer,
  ScatterChart,
  Scatter,
  ZAxis,
  Cell,
  ReferenceLine,
  Label,
  LabelList
} from 'recharts';

const IndividualStudentAnalysis = () => {
  // Student data - individual performance for all 60 students
  const studentData = [
    {"studentId":"S1","group":"Experimental","test1":25,"test2":30,"improvement":5,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S2","group":"Experimental","test1":39,"test2":40,"improvement":1,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S4","group":"Experimental","test1":44,"test2":44,"improvement":0,"cerf":"B2","quartile":"Q4 (Highest)"},
    {"studentId":"S5","group":"Control","test1":37,"test2":37,"improvement":0,"cerf":"B2","quartile":"Q2"},
    {"studentId":"S6","group":"Control","test1":37,"test2":37,"improvement":0,"cerf":"B1","quartile":"Q2"},
    {"studentId":"S7","group":"Experimental","test1":47,"test2":47,"improvement":0,"cerf":"B2","quartile":"Q4 (Highest)"},
    {"studentId":"S9","group":"Control","test1":28,"test2":28,"improvement":0,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S12","group":"Experimental","test1":45,"test2":45,"improvement":0,"cerf":"B2","quartile":"Q4 (Highest)"},
    {"studentId":"S13","group":"Experimental","test1":24,"test2":26,"improvement":2,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S15","group":"Control","test1":36,"test2":36,"improvement":0,"cerf":"B1","quartile":"Q2"},
    {"studentId":"S17","group":"Control","test1":38,"test2":39,"improvement":1,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S18","group":"Control","test1":32,"test2":32,"improvement":0,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S19","group":"Experimental","test1":15,"test2":19,"improvement":4,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S20","group":"Control","test1":42,"test2":42,"improvement":0,"cerf":"B1","quartile":"Q4 (Highest)"},
    {"studentId":"S21","group":"Control","test1":28,"test2":28,"improvement":0,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S22","group":"Experimental","test1":40,"test2":40,"improvement":0,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S23","group":"Experimental","test1":36,"test2":38,"improvement":2,"cerf":"B2","quartile":"Q2"},
    {"studentId":"S26","group":"Experimental","test1":39,"test2":39,"improvement":0,"cerf":"B1","quartile":"Q3"},
    {"studentId":"S27","group":"Experimental","test1":14,"test2":14,"improvement":0,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S28","group":"Experimental","test1":41,"test2":41,"improvement":0,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S29","group":"Control","test1":45,"test2":45,"improvement":0,"cerf":"B2","quartile":"Q4 (Highest)"},
    {"studentId":"S30","group":"Experimental","test1":40,"test2":41,"improvement":1,"cerf":"B1","quartile":"Q3"},
    {"studentId":"S31","group":"Experimental","test1":38,"test2":40,"improvement":2,"cerf":"B1","quartile":"Q3"},
    {"studentId":"S33","group":"Experimental","test1":44,"test2":45,"improvement":1,"cerf":"B2","quartile":"Q4 (Highest)"},
    {"studentId":"S34","group":"Experimental","test1":49,"test2":49,"improvement":0,"cerf":"B2","quartile":"Q4 (Highest)"},
    {"studentId":"S39","group":"Experimental","test1":42,"test2":42,"improvement":0,"cerf":"B2","quartile":"Q4 (Highest)"},
    {"studentId":"S40","group":"Experimental","test1":32,"test2":33,"improvement":1,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S43","group":"Control","test1":29,"test2":29,"improvement":0,"cerf":"B2","quartile":"Q1 (Lowest)"},
    {"studentId":"S45","group":"Experimental","test1":35,"test2":37,"improvement":2,"cerf":"B2","quartile":"Q2"},
    {"studentId":"S46","group":"Control","test1":32,"test2":31,"improvement":-1,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S47","group":"Control","test1":37,"test2":37,"improvement":0,"cerf":"B2","quartile":"Q2"},
    {"studentId":"S48","group":"Control","test1":43,"test2":43,"improvement":0,"cerf":"B2","quartile":"Q4 (Highest)"},
    {"studentId":"S51","group":"Experimental","test1":34,"test2":34,"improvement":0,"cerf":"B1","quartile":"Q2"},
    {"studentId":"S55","group":"Experimental","test1":30,"test2":29,"improvement":-1,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S56","group":"Experimental","test1":44,"test2":44,"improvement":0,"cerf":"B2","quartile":"Q4 (Highest)"},
    {"studentId":"S58","group":"Control","test1":20,"test2":18,"improvement":-2,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S59","group":"Experimental","test1":40,"test2":40,"improvement":0,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S60","group":"Control","test1":40,"test2":40,"improvement":0,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S62","group":"Control","test1":27,"test2":27,"improvement":0,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S63","group":"Control","test1":10,"test2":12,"improvement":2,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S64","group":"Experimental","test1":40,"test2":40,"improvement":0,"cerf":"B1","quartile":"Q3"},
    {"studentId":"S65","group":"Experimental","test1":33,"test2":36,"improvement":3,"cerf":"B2","quartile":"Q2"},
    {"studentId":"S66","group":"Experimental","test1":30,"test2":32,"improvement":2,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S67","group":"Control","test1":36,"test2":36,"improvement":0,"cerf":"B1","quartile":"Q2"},
    {"studentId":"S69","group":"Control","test1":37,"test2":37,"improvement":0,"cerf":"B2","quartile":"Q2"},
    {"studentId":"S71","group":"Experimental","test1":38,"test2":39,"improvement":1,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S72","group":"Control","test1":31,"test2":31,"improvement":0,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S73","group":"Experimental","test1":36,"test2":35,"improvement":-1,"cerf":"B1","quartile":"Q2"},
    {"studentId":"S74","group":"Control","test1":43,"test2":44,"improvement":1,"cerf":"B2","quartile":"Q4 (Highest)"},
    {"studentId":"S75","group":"Control","test1":41,"test2":41,"improvement":0,"cerf":"B1","quartile":"Q3"},
    {"studentId":"S76","group":"Control","test1":19,"test2":17,"improvement":-2,"cerf":"B1","quartile":"Q1 (Lowest)"},
    {"studentId":"S77","group":"Control","test1":34,"test2":34,"improvement":0,"cerf":"B2","quartile":"Q2"},
    {"studentId":"S78","group":"Experimental","test1":34,"test2":37,"improvement":3,"cerf":"B2","quartile":"Q2"},
    {"studentId":"S80","group":"Control","test1":40,"test2":41,"improvement":1,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S82","group":"Control","test1":40,"test2":41,"improvement":1,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S83","group":"Control","test1":40,"test2":41,"improvement":1,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S85","group":"Control","test1":40,"test2":40,"improvement":0,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S86","group":"Control","test1":33,"test2":34,"improvement":1,"cerf":"B1","quartile":"Q2"},
    {"studentId":"S87","group":"Control","test1":41,"test2":41,"improvement":0,"cerf":"B2","quartile":"Q3"},
    {"studentId":"S88","group":"Experimental","test1":41,"test2":41,"improvement":0,"cerf":"B2","quartile":"Q3"}
  ];

  // Sort students by improvement (descending) for the bar chart
  const sortedByImprovement = [...studentData].sort((a, b) => b.improvement - a.improvement);

  // State for student highlight and filtering
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [filterGroup, setFilterGroup] = useState("all"); // "all", "Experimental" or "Control"
  const [filterCERF, setFilterCERF] = useState("all"); // "all", "A2", "B1" or "B2"
  const [filterQuartile, setFilterQuartile] = useState("all"); // "all", "Q1 (Lowest)", "Q2", "Q3", "Q4 (Highest)"

  // Apply filters
  const filteredStudents = studentData.filter(student => {
    return (filterGroup === "all" || student.group === filterGroup) &&
           (filterCERF === "all" || student.cerf === filterCERF) &&
           (filterQuartile === "all" || student.quartile === filterQuartile);
  });

  const filteredSorted = [...filteredStudents].sort((a, b) => b.improvement - a.improvement);

  return (
    <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '2rem', backgroundColor: '#F9FAFB' }}>
      <div style={{ marginBottom: '2rem', backgroundColor: '#FFFFFF', boxShadow: '0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06)', borderRadius: '0.5rem', padding: '1.5rem' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1.5rem', color: '#1F2937' }}>
          Individual Student Performance Analysis
        </h1>
        
        {/* Filters */}
        <div style={{ marginBottom: '1.5rem', display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <div>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 500, color: '#374151', marginBottom: '0.25rem' }}>
              Group
            </label>
            <select 
              style={{ padding: '0.5rem', border: '1px solid #D1D5DB', borderRadius: '0.25rem' }}
              value={filterGroup}
              onChange={(e) => setFilterGroup(e.target.value)}
            >
              <option value="all">All Groups</option>
              <option value="Experimental">Experimental</option>
              <option value="Control">Control</option>
            </select>
          </div>
          
          <div>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 500, color: '#374151', marginBottom: '0.25rem' }}>
              CERF Level
            </label>
            <select 
              style={{ padding: '0.5rem', border: '1px solid #D1D5DB', borderRadius: '0.25rem' }}
              value={filterCERF}
              onChange={(e) => setFilterCERF(e.target.value)}
            >
              <option value="all">All Levels</option>
              {/* <option value="A2">A2 (Basic)</option> */}
              <option value="B1">B1 (Intermediate)</option>
              <option value="B2">B2 (Upper Intermediate)</option>
            </select>
          </div>
          
          <div>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 500, color: '#374151', marginBottom: '0.25rem' }}>
              Initial Performance
            </label>
            <select 
              style={{ padding: '0.5rem', border: '1px solid #D1D5DB', borderRadius: '0.25rem' }}
              value={filterQuartile}
              onChange={(e) => setFilterQuartile(e.target.value)}
            >
              <option value="all">All Quartiles</option>
              <option value="Q1 (Lowest)">Q1 (Lowest)</option>
              <option value="Q2">Q2</option>
              <option value="Q3">Q3</option>
              <option value="Q4 (Highest)">Q4 (Highest)</option>
            </select>
          </div>
        </div>
        
        {/* Scatter Plot - Test 1 vs Test 2 Scores */}
        <div style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.75rem', color: '#6B21A8' }}>
            Test 1 vs Test 2 Performance
          </h2>
          <div style={{ height: '24rem' }}>
            <ResponsiveContainer width="100%" height="100%">
              <ScatterChart margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                  type="number" 
                  dataKey="test1" 
                  name="Test 1 Score" 
                  domain={[0, 50]}
                  label={{ value: 'Test 1 Score', position: 'insideBottom', offset: -5 }}
                />
                <YAxis 
                  type="number" 
                  dataKey="test2" 
                  name="Test 2 Score" 
                  domain={[0, 50]}
                  label={{ value: 'Test 2 Score', angle: -90, position: 'insideLeft' }}
                />
                <ZAxis 
                  type="number"
                  dataKey="improvement"
                  range={[60, 300]}
                  name="Improvement"
                />
                <Tooltip 
                  cursor={{ strokeDasharray: '3 3' }}
                  formatter={(value, name, props) => {
                    if (name === 'Test 2 Score') {
                      return [`${value} (Improvement: ${props.payload.improvement})`, name];
                    }
                    return [value, name];
                  }}
                  labelFormatter={(value) => `Student: ${filteredStudents.find(s => s.test1 === value)?.studentId}`}
                />
                <Legend />
                <ReferenceLine y="x" stroke="gray" strokeDasharray="3 3" />
                
                {/* Experimental Group */}
                <Scatter 
                  name="Experimental Group" 
                  data={filteredStudents.filter(s => s.group === "Experimental")} 
                  fill="#8884d8"
                  shape={(props) => {
                    const { cx, cy, fill } = props;
                    const isSelected = selectedStudent === props.payload.studentId;
                    return (
                      <circle 
                        cx={cx} 
                        cy={cy} 
                        r={isSelected ? 8 : 5}
                        fill={isSelected ? "#ff7300" : fill}
                        stroke={isSelected ? "#000" : "none"}
                        strokeWidth={isSelected ? 2 : 0}
                        style={{ cursor: 'pointer' }}
                      />
                    );
                  }}
                  onClick={(data) => setSelectedStudent(data.studentId === selectedStudent ? null : data.studentId)}
                />
                
                {/* Control Group */}
                <Scatter 
                  name="Control Group" 
                  data={filteredStudents.filter(s => s.group === "Control")} 
                  fill="#82ca9d"
                  shape={(props) => {
                    const { cx, cy, fill } = props;
                    const isSelected = selectedStudent === props.payload.studentId;
                    return (
                      <circle 
                        cx={cx} 
                        cy={cy} 
                        r={isSelected ? 8 : 5}
                        fill={isSelected ? "#ff7300" : fill}
                        stroke={isSelected ? "#000" : "none"}
                        strokeWidth={isSelected ? 2 : 0}
                        style={{ cursor: 'pointer' }}
                      />
                    );
                  }}
                  onClick={(data) => setSelectedStudent(data.studentId === selectedStudent ? null : data.studentId)}
                />
              </ScatterChart>
            </ResponsiveContainer>
          </div>
          <p style={{ fontSize: '0.875rem', color: '#4B5563', marginTop: '0.5rem' }}>
            This scatter plot shows each student's Test 1 score (x-axis) versus Test 2 score (y-axis).
            Points above the diagonal line represent students who improved, while points below show a performance decline.
            The size of each point represents the magnitude of change. Click on any point to highlight a student.
          </p>
        </div>
        
        {/* Bar Chart - Individual Student Improvement */}
        <div style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.75rem', color: '#3730A3' }}>
            Individual Student Improvement
          </h2>
          <div style={{ height: '24rem', overflowX: 'auto' }}>
            <div style={{ width: `${Math.max(1000, filteredSorted.length * 20)}px`, height: '100%' }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  data={filteredSorted}
                  margin={{ top: 20, right: 30, left: 20, bottom: 120 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis 
                    dataKey="studentId" 
                    interval={0}
                    angle={-90}
                    textAnchor="end"
                    tick={{ fontSize: 11 }}
                    height={120}
                  />
                  <YAxis 
                    domain={[-3, 6]} 
                    label={{ value: 'Score Improvement', angle: -90, position: 'insideLeft' }}
                  />
                  <Tooltip 
                    formatter={(value, name, props) => [
                      value,
                      'Improvement',
                      `Student: ${props.payload.studentId}, Group: ${props.payload.group}, CERF: ${props.payload.cerf}, Initial: ${props.payload.quartile}`
                    ]}
                  />
                  <Legend />
                  <Bar dataKey="improvement" name="Score Improvement">
                    {filteredSorted.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={
                          entry.studentId === selectedStudent 
                            ? '#ff7300' 
                            : entry.group === 'Experimental'
                              ? (entry.improvement >= 0 ? '#8884d8' : '#D66EF7')
                              : (entry.improvement >= 0 ? '#82ca9d' : '#F48FB1')
                        }
                        stroke={entry.studentId === selectedStudent ? "#000" : "none"}
                        strokeWidth={entry.studentId === selectedStudent ? 2 : 0}
                        cursor="pointer"
                        onClick={() => setSelectedStudent(entry.studentId === selectedStudent ? null : entry.studentId)}
                      />
                    ))}
                    <LabelList dataKey="studentId" position="insideTop" style={{ fontSize: 0 }} />
                  </Bar>
                  <ReferenceLine y={0} stroke="#000" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
          <p style={{ fontSize: '0.875rem', color: '#4B5563', marginTop: '0.5rem' }}>
            This bar chart shows the improvement for each student, sorted from highest to lowest.
            Experimental group is shown in purple, control group in green. Negative values (decline) are shown in lighter shades.
            Click on any bar to highlight a student. Scroll horizontally to view all students.
          </p>
        </div>
        
        {/* Selected Student Details */}
        {selectedStudent && (
          <div style={{ marginBottom: '1rem' }}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.75rem', color: '#EA580C' }}>
              Selected Student Details
            </h2>
            {(() => {
              const student = studentData.find(s => s.studentId === selectedStudent);
              return (
                <div style={{ backgroundColor: '#FFF7ED', padding: '1rem', borderRadius: '0.5rem' }}>
                  <h3 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                    {student.studentId} ({student.group})
                  </h3>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem' }}>
                    <div>
                      <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
                        <span style={{ fontWeight: 600 }}>CERF Level:</span> {student.cerf}
                      </p>
                      <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
                        <span style={{ fontWeight: 600 }}>Initial Performance:</span> {student.quartile}
                      </p>
                      <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
                        <span style={{ fontWeight: 600 }}>Test 1 Score:</span> {student.test1}/50
                      </p>
                      <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
                        <span style={{ fontWeight: 600 }}>Test 2 Score:</span> {student.test2}/50
                      </p>
                      <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem', fontWeight: 'bold', color: student.improvement > 0 ? 'green' : student.improvement < 0 ? 'red' : 'gray' }}>
                        <span style={{ fontWeight: 600, color: 'black' }}>Improvement:</span> {student.improvement > 0 ? '+' : ''}{student.improvement} points
                      </p>
                    </div>
                    <div style={{ gridColumn: 'span 2' }}>
                      <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
                        <span style={{ fontWeight: 600 }}>Key Observations:</span>
                      </p>
                      <ul style={{ listStyleType: 'disc', paddingLeft: '1rem', fontSize: '0.875rem' }}>
                        {student.improvement > 2 && (
                          <li>Showed significant improvement (top 10% of all students)</li>
                        )}
                        {student.improvement < 0 && (
                          <li>Performance declined between tests</li>
                        )}
                        {student.improvement === 0 && student.test1 > 40 && (
                          <li>Already high-performing with limited room for improvement</li>
                        )}
                        {student.improvement === 0 && student.test1 <= 40 && (
                          <li>Maintained consistent performance across both tests</li>
                        )}
                        {student.group === "Experimental" && student.improvement > 0 && student.quartile === "Q1 (Lowest)" && (
                          <li>Lower-performing experimental group student who benefited from the crash course</li>
                        )}
                        {student.group === "Control" && student.improvement > 0 && (
                          <li>Control group student who improved without the crash course</li>
                        )}
                        {student.group === "Experimental" && student.improvement <= 0 && (
                          <li>Did not benefit from the crash course</li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        )}
        
        {/* Summary Statistics */}
        <div style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.75rem', color: '#1E40AF' }}>
            Current Selection Summary
          </h2>
          <div style={{ backgroundColor: '#EFF6FF', padding: '1rem', borderRadius: '0.5rem' }}>
            {(() => {
              const totalStudents = filteredStudents.length;
              const experimental = filteredStudents.filter(s => s.group === "Experimental").length;
              const control = filteredStudents.filter(s => s.group === "Control").length;
              
              const avgImprovement = filteredStudents.reduce((sum, s) => sum + s.improvement, 0) / totalStudents;
              const avgExpImprovement = filteredStudents.filter(s => s.group === "Experimental").reduce((sum, s) => sum + s.improvement, 0) / (experimental || 1);
              const avgCtrlImprovement = filteredStudents.filter(s => s.group === "Control").reduce((sum, s) => sum + s.improvement, 0) / (control || 1);
              
              const improved = filteredStudents.filter(s => s.improvement > 0).length;
              const declined = filteredStudents.filter(s => s.improvement < 0).length;
              const unchanged = filteredStudents.filter(s => s.improvement === 0).length;
              
              return (
                <>
                  <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
                    <span style={{ fontWeight: 600 }}>Students in selection:</span> {totalStudents} ({experimental} experimental, {control} control)
                  </p>
                  <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
                    <span style={{ fontWeight: 600 }}>Average improvement:</span> {avgImprovement.toFixed(2)} points
                  </p>
                  <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
                    <span style={{ fontWeight: 600 }}>Experimental group avg:</span> {avgExpImprovement.toFixed(2)} points
                  </p>
                  <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
                    <span style={{ fontWeight: 600 }}>Control group avg:</span> {avgCtrlImprovement.toFixed(2)} points
                  </p>
                  <p style={{ fontSize: '0.875rem', marginBottom: '0.25rem' }}>
                    <span style={{ fontWeight: 600 }}>Performance changes:</span> {improved} improved, {unchanged} unchanged, {declined} declined
                  </p>
                </>
              );
            })()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndividualStudentAnalysis;
